import { useCallback, useState } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

import FormCard from 'src/components/ui/FormCard';
import CustomOption from 'src/components/ui/CustomOption';
import AutocompleteCFormik from 'src/components/ui/Autocomplete/connectors/AutocompleteCFormik';
import { mapContactOptionToChangeFormValues } from 'src/utils/mappers/eventForm/contact.mapper';

import DefaultFormCPersonNumber from './PersonNumber';
import DefaultFormCCommonNumber from './CommonNumber';
import { useFormChangeContact } from '../hooks/useFormChangeContact';

const DefaultFormCChangeContact = (props) => {
	const {
		fullHeight,
		contacts = [],
		targetContact,
		onCancel,
		onChangeContact,
		onSubmit,
		serverError,
		...rest
	} = props;

	const [isPersonal, setIsPersonal] = useState(false);

	const { initialValues, statuses, validationSchema } = useFormChangeContact({
		values: targetContact,
		isPersonal,
	});

	const handleTargetChange = useCallback(
		(option, setValues) => {
			setIsPersonal(Boolean(option?.isPerson));
			setValues(mapContactOptionToChangeFormValues(option));
			onChangeContact?.(option);
		},
		[onChangeContact],
	);

	const handleSubmit = useCallback(
		async (values) => {
			if (onSubmit) {
				await onSubmit(values);
			}
		},
		[onSubmit],
	);

	let result = (
		<Formik
			onSubmit={handleSubmit}
			initialValues={initialValues}
			validationSchema={validationSchema}
			validateOnChange={false}
			enableReinitialize
		>
			{(formikProps) => {
				const { values, setValues } = formikProps;

				return (
					<FormCard
						title="Изменить контакт"
						fullHeight={fullHeight}
						error={serverError}
						onCancel={onCancel}
						onAccept={formikProps.submitForm}
						acceptLabel="Изменить"
						isLoading={formikProps.isSubmitting}
					>
						<Stack spacing={2}>
							<AutocompleteCFormik
								label="Контакт"
								name="target"
								options={contacts}
								onChange={(option) =>
									handleTargetChange(option, setValues)
								}
							/>
							{values.target && (
								<>
									<AutocompleteCFormik
										label="Статус"
										name="status"
										options={statuses}
									/>
									{isPersonal ? (
										<DefaultFormCPersonNumber
											isPlain
											values={values}
											{...rest}
										/>
									) : (
										<DefaultFormCCommonNumber
											isPlain
											values={values}
											{...rest}
										/>
									)}
								</>
							)}
						</Stack>
					</FormCard>
				);
			}}
		</Formik>
	);

	return result;
};

DefaultFormCChangeContact.propTypes = {
	isPlain: PropTypes.bool,
	onSubmit: PropTypes.func,
	contacts: PropTypes.arrayOf(PropTypes.shape(CustomOption.propTypes)),
	serverError: PropTypes.string,
	fullHeight: PropTypes.bool,
	targetContact: PropTypes.object.isRequired,
	onCancel: PropTypes.func.isRequired,
	onChangeContact: PropTypes.func.isRequired,
};

export default DefaultFormCChangeContact;
